import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BPProfilesCatalogService } from './bp-profiles-catalog.service';
import { BPProfilesCatalogDataService, IOrderableItemResponse } from './bp-profiles-catalog-data.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { LOV_CATALOG_TYPES, LovService } from '../../../../shared/services/lov.service';
import { ILov } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { util } from '../../../../shared/util';

@Component({
  selector: 'bp-profiles-catalog',
  template: `
    <h2 *ngIf="loading"><activity-indicator></activity-indicator></h2>
    <ui-view *ngIf="!loading"></ui-view>
  `,
  styleUrls: ['./bp-profiles-catalog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesCatalogComponent implements OnInit, OnDestroy {
  public loading:boolean;

  constructor(
    private bpProfilesService:BPProfilesService,
    private bpProfilesCatalogService:BPProfilesCatalogService,
    private bpProfilesCatalogDataService:BPProfilesCatalogDataService,
    private lovService:LovService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.loading = true;
    Promise.all([
      this.lovService.list(LOV_CATALOG_TYPES),
      this.bpProfilesCatalogDataService.getCatalogItems(this.bpProfilesService.activeProfile?.id)
    ]).then(util.spread((catalogTypes:ILov[], orderableItemResponse:IOrderableItemResponse) => {
      this.bpProfilesCatalogService.catalogTypes = _.sortBy(catalogTypes, 'value');
      this.bpProfilesCatalogService.currency = orderableItemResponse?.currency;
      this.bpProfilesCatalogService.orderableItems = orderableItemResponse?.items;
    })).finally(() => {
      this.loading = false;
    });
  }

  public ngOnDestroy():void {
    this.bpProfilesCatalogService.clear();
  }
}